import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';

interface GeneralDropdownsTriggersTriggerStaticSignature {
  Args: {
    buttonType: 'secondary';
    iconBefore?: IconName;
    isTriggerSmall?: boolean;
    label: string;
    select?: {
      isOpen: boolean;
    };
  };
}

const GeneralDropdownsTriggersTriggerStatic = <template>
  <PrismButton
    @buttonType={{@buttonType}}
    @icon={{if @select.isOpen "chevron-up" "chevron-down"}}
    @iconBefore={{@iconBefore}}
    @isSmall={{@isTriggerSmall}}
    @label={{@label}}
  />
</template> satisfies TOC<GeneralDropdownsTriggersTriggerStaticSignature>;

export default GeneralDropdownsTriggersTriggerStatic;
